// ROS Topics
export const TOPIC_STATE_ROBOT_CONNECTION = "/connected";
export const TOPIC_STATE_MODE = "/state/mode";
export const TOPIC_STATE_HEIGHT = "/state/height";
export const TOPIC_STATE_MAX_SPEED = "/state/max_speed";
export const TOPIC_STATE_MOTOR = "/state/motor";
export const TOPIC_STATE_ESTOP = "/state/estop";
export const TOPIC_STATE_SELFRIGHT = "/state/selfright";
export const TOPIC_STATE_TURNOVER = "/state/turnover";
export const TOPIC_STATE_MOVEMENT = "/state/movement";
export const TOPIC_STATE_RESET = "/state/reset";

export const TOPIC_STATE_LIGHT = "/state/light";
export const TOPIC_STATE_BRIGHTNESS = "/state/brightness";

export const TOPIC_STATE_BATTERY_CHARGE = "/state/battery/charge";
export const TOPIC_STATE_BATTERY_STATUS = "/state/battery/status";
export const TOPIC_STATE_BATTERY_TEMP = "/state/battery/temperature";
export const TOPIC_STATE_BATTERY_RAW = "/state/battery/raw";
export const TOPIC_STATE_BATTERY_RUNTIME = "/state/battery/est_runtime";
export const TOPIC_STATE_PROXIMITIES = "/state/proximities";

export const TOPIC_STATE_CLAIM_MOTOR = "/state/claim/motor";
export const TOPIC_STATE_CLAIM_ESTOP = "/state/claim/estop";

export const TOPIC_STATE_MISSION_RECORD = "/record/state";
export const TOPIC_STATE_MISSION_RUN = "/mission/playing/state";

export const ROBOT_POSITION_TOPIC = "/map/robot/position";

export const SUB_LIVE_MAP = "/map/compressed";
export const PUB_SCAN_MAP = "/map/scan";
export const SERVICE_LIST_MAP = "/map/list_maps";
export const SERVICE_MAP_VIEW = "/map/get_map";
export const SERVICE_LIST_MISSIONS = "/mission/list_missions";
export const SERVICE_GET_MISSION = "/mission/get_mission";
export const SERVICE_GET_LANDMARKS = "/map/get_landmarks";
export const SERVICE_CREATE_LANDMARKS = "/map/create_landmarks";
export const SERVICE_LIST_LANDMARKS = "/map/get_landmarks";
export const SERVICE_MAP_SYS_START = "/map/start_system";
export const SERVICE_MAP_SYS_STOP = "/map/stop_system";
export const SERVICE_TO_LANDMARK = "/landmarks/to_pose";
export const TOPIC_NAV_CONTROL = "/nav/state/config";
export const TOPIC_NAV_STATE = "/nav/state";

export const TOPIC_STATE_INSPECTION_RESULT =
  "/mission/run/custom_action_result";
export const TOPIC_STATE_INSPECTION_STATUS =
  "/mission/run/custom_action_status";

export const TOPIC_STATE_NOTIFICATIONS = "/state/notifications";

export const TOPIC_STATE_HAS_ARM = "/state/has_arm";
export const TOPIC_STATE_AUTO_GRIP = "/arm/state/arm_action";
export const TOPIC_STATE_ARM_VELOCITY = "/arm/state/arm_velocity";
export const TOPIC_STATE_WRIST_VELOCITY = "/arm/state/wrist_velocity";
export const TOPIC_STATE_VELOCITY_CMD_DURATION =
  "/arm/state/velocity_cmd_duration";
export const TOPIC_STATE_GRIPPER_TORQUE = "/arm/state/gripper_torque";
export const TOPIC_STATE_FOLLOW_ARM = "/arm/state/follow_arm";
export const TOPIC_STATE_DISABLE_WALK = "/arm/state/follow_arm_disable_walk";
export const TOPIC_STATE_ARM_MODE = "/arm/state/mode";
export const TOPIC_STATE_ARM_JOINT_POS = "/state/arm_joint/position";
export const TOPIC_STATE_ARM_END_POS = "/arm/state/end_effector_state";
export const TOPIC_STATE_ARM_GRIP_DEPTH = "/arm/state/gripper_depth";
export const TOPIC_STATE_ARM_TORQUE = "/arm/state/gripper_torque";

/* Connection states */
export const STATE_ROBOT_CONNECTING = "ROBOT_CONNECTING";
export const STATE_ROBOT_CONNECTED = "ROBOT_CONNECTED";
export const STATE_ROBOT_DISCONNECTED = "ROBOT_DISCONNECTED";
export const STATE_JETPACK_CONNECTING = "JETPACK_CONNECTING";
export const STATE_JETPACK_CONNECTED = "JETPACK_CONNECTED";
export const STATE_JETPACK_DISCONNECTED = "JETPACK_DISCONNECTED";

/* Battery states */
export const STATE_BATTERY_CHARGING = "BATTERY_CHARGING";
export const STATE_BATTERY_DISCHARGING = "BATTERY_DISCHARGING";
export const STATE_BATTERY_BOOTING = "BATTERY_BOOTING";
export const STATE_BATTERY_UNKNOWN = "BATTERY_UNKNOWN";
export const STATE_BATTERY_MISSING = "BATTERY_MISSING";

/* Stream states */
export const STATE_STREAM_OKAY = "STREAM_OKAY";
export const STATE_STREAM_SLOW = "STREAM_SLOW";
export const STATE_STREAM_NONE = "STREAM_NONE";

/* WiFi states */
export const STATE_WIFI_CONNECTING = "WIFI_CONNECTING";
export const STATE_WIFI_CONNECTED = "WIFI_CONNECTED";
export const STATE_WIFI_MODIFIED = "WIFI_MODIFIED";
export const STATE_WIFI_DISCONNECTED = "WIFI_DISCONNECTED";
export const STATE_WIFI_FAILED = "WIFI_FAILED";
export const STATE_WIFI_SSID_NOT_FOUND = "WIFI_SSID_NOT_FOUND";
export const STATE_WIFI_PW_INCORRECT = "WIFI_PW_INCORRECT";

/* Motor states */
export const STATE_MOTOR_POWERED_OFF = "POWERED_OFF";
export const STATE_MOTOR_POWERED_ON = "POWERED_ON";
export const STATE_MOTOR_POWERING_ON = "POWERING_ON";
export const STATE_MOTOR_POWERING_OFF = "POWERING_OFF";
export const STATE_MOTOR_ERROR = "ERROR";
export const STATE_MOTOR_UNKNOWN = "MOTOR_UNKNOWN";
export const STATE_ERROR = "ERROR";

/* Claim states */
export const STATE_CLAIM_CLAIMED = "CLAIMED";
export const STATE_CLAIM_NO_CLAIM = "NO_CLAIM";
export const STATE_CLAIM_NOT_YOURS = "NOT_YOURS";
export const STATE_CLAIM_UNKNOWN = "CLAIM_UNKNOWN";

/* Record event */
export const STATE_RECORD_STARTING = "START";
export const STATE_RECORD_STARTED = "RECORD_STARTED";
export const STATE_RECORD_STOPPING = "RECORD_STOPPING";
export const STATE_RECORD_STOPPED = "STOP";
export const STATE_RECORD_FAILED = "RECORD_FAILED";
export const STATE_RECORD_STATE_UPDATED = "STATE_UPDATED";

export const STATE_MISSION_GENERATING = "MISSION_GENERATING";
export const STATE_MISSION_GENERATING_FAILED = "MISSION_GENERATING_FAILED";
export const STATE_MISSION_GENERATED = "MISSION_GENERATED";

export const STATES_RECORD_END_STATES = [
  STATE_RECORD_FAILED,
  STATE_MISSION_GENERATED,
  STATE_MISSION_GENERATING_FAILED,
];

/* Replay event */
export const STATE_NAV_STARTED = "START";
export const STATE_NAV_STARTING = "START";
export const STATE_NAV_LOADING = "LOADING";
export const STATE_NAV_STOPPED = "STOP";
export const STATE_MISSION_STARTING = "START";
export const STATE_MISSION_STARTED = "MISSION_STARTED";
export const STATE_MISSION_PAUSING = "MISSION_PAUSING";
export const STATE_MISSION_PAUSED = "PAUSE";
export const STATE_MISSION_STOPPING = "MISSION_STOPPING";
export const STATE_MISSION_STOPPED = "STOP";
export const STATE_MISSION_UPDATE = "MISSION_UPDATE";
export const STATE_MISSION_LOCATION = "MISSION_LOCATION";
export const STATE_MISSION_FAILED = "MISSION_FAILED";
export const STATE_CUSTOM_ACTION_STARTED = "CUSTOM_ACTION_STARTED";
export const STATE_CUSTOM_ACTION_FINISHED = "CUSTOM_ACTION_FINISHED";

export const STATES_MISSION_END_STATES = [
  STATE_MISSION_FAILED,
  STATE_MISSION_STOPPED,
];

/* Login states */
export const STATE_LOGGED_IN = "LOGGED_IN";
export const STATE_LOGGING_IN = "LOGGING_IN";
export const STATE_LOGGED_OUT = "LOGGED_OUT";
export const STATE_LOGGING_OUT = "LOGGING_OUT";
export const STATE_LOGIN_FAILED = "LOGIN_FAILED";

/* Arm states */
export const STATE_ARM_STOWED = "STOWED";
export const STATE_ARM_UNSTOWED = "UNSTOWED";
export const STATE_ARM_CARRY = "CARRY";

export const RecordEvents = {
  STATE_RECORD_STARTING,
  STATE_RECORD_STARTED,
  STATE_RECORD_STOPPING,
  STATE_RECORD_STOPPED,
  STATE_RECORD_FAILED,

  STATE_MISSION_GENERATING,
  STATE_MISSION_GENERATING_FAILED,
  STATE_MISSION_GENERATED,
};

export const ReplayEvents = {
  STATE_MISSION_STARTING,
  STATE_MISSION_STARTED,
  STATE_MISSION_PAUSING,
  STATE_MISSION_PAUSED,
  STATE_MISSION_STOPPING,
  STATE_MISSION_STOPPED,
  STATE_MISSION_UPDATE,
  STATE_MISSION_LOCATION,
  STATE_MISSION_FAILED,
  STATE_CUSTOM_ACTION_STARTED,
  STATE_CUSTOM_ACTION_FINISHED,
};

/* ros_media_stream topics and states */
const STREAM_PREFIX = "/ros_media_stream";
export const TOPIC_STREAM_SHUTDOWN = `${STREAM_PREFIX}/shutdown`;
export const TOPIC_STREAM_RECORD = `${STREAM_PREFIX}/record`;
export const TOPIC_STREAM_STATE_RECORD = `${STREAM_PREFIX}/state/record`;

export const STATE_STREAM_RECORD_STARTED = "RECORD_STARTED";
export const STATE_STREAM_RECORD_STOPPED = "RECORD_STOPPED";
export const STATE_STREAM_RECORD_FAILED = "RECORD_FAILED";

/* Errors */
export const ERROR_NO_MISSION = "NO_MISSION";
export const ERROR_NO_EXTERNAL_ESTOP = "NO_EXTERNAL_ESTOP";
export const ERROR_NO_CONTROL = "NO_CONTROL";
export const ERROR_CANT_TAKE_CONTROL = "COULD_NOT_TAKE_CONTROL";
export const ERROR_ROBOT_UNAVAILABLE = "ROBOT_UNAVAILABLE";
export const ERROR_ROBOT_POWERED_OFF = "ROBOT_POWERED_OFF";
export const ERROR_ROBOT_FAULTED = "ROBOT_FAULTED";
export const ERROR_RECORD_CORRUPTED = "RECORD_CORRUPTED";
export const ERROR_UNKNOWN_MAP_INFO = "UNKNOWN_MAP_INFO";
export const ERROR_GRAPHNAV_SERVICE_FAILED = "GRAPHNAV_SERVICE_FAILED";
export const ERROR_TIMEOUT = "TIMEOUT";
export const ERROR_SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE";
export const ERROR_INVALID_REQUEST = "INVALID_REQUEST";
export const ERROR_LOCALIZED_FAILED = "LOCALIZED_FAILED";

export const ERROR_NO_VISIBLE_FIDUCIAL = "NO_VISIBLE_FIDUCIAL";
export const ERROR_NO_MATCHING_FIDUCIAL = "NO_MATCHING_FIDUCIAL";
export const ERROR_CANT_CREATE_WAYPOINT = "COULD_NOT_CREATE_WAYPOINT";
export const ERROR_DISK_FULL = "DISK_FULL";
export const ERROR_FILESYSTEM_ERROR = "FILESYSTEM_ERROR";
export const ERROR_UNKNOWN = "ERROR_UNKNOWN";

export const MissionErrors = {
  ERROR_NO_MISSION,
  ERROR_NO_EXTERNAL_ESTOP,
  ERROR_NO_CONTROL,
  ERROR_ROBOT_UNAVAILABLE,
  ERROR_ROBOT_POWERED_OFF,
  ERROR_ROBOT_FAULTED,
  ERROR_UNKNOWN_MAP_INFO,
  ERROR_GRAPHNAV_SERVICE_FAILED,
  ERROR_TIMEOUT,
  ERROR_SERVICE_UNAVAILABLE,
  ERROR_INVALID_REQUEST,
};
